const isReceived = (status?: string) =>
  status !== 'ToBeReceived' &&
  status !== 'ToBeReceivedAfterRejection' &&
  status !== 'Inactive' &&
  status !== undefined;

export default isReceived;
